import React, { FC } from 'react';
import { StyledShowcasesSelectionEntity } from '@funtech-int/kp-graphql-sdk/yango-movies-www';
import { RouterLocation } from '@funtech-int/rival';
import { Picture, createPictureFactory } from '@funtech-int/yango-shared';

import * as CardKit from '../CardKit';

import styles from './_StyledShowcase.module.css';

const gradientPictureFactory = createPictureFactory({
    fallback: {
        src: '1280xhq',
    },
});

const logoPictureFactory = createPictureFactory({
    fallback: {
        src: 'x120',
    },
});

const backgroundPictureFactory = createPictureFactory({
    fallback: {
        src: '1280xhq',
    },
});

interface StyledShowcaseProps {
    entity: StyledShowcasesSelectionEntity;
    location: RouterLocation<any, any>;
    searchParams?: URLSearchParams;
    onShow?: VoidFunction;
    onClick?: VoidFunction;
}

export const StyledShowcase: FC<StyledShowcaseProps> = ({
    entity,
    location,
    searchParams,
    onShow,
    onClick,
}) => {
    const { img: gradient } = gradientPictureFactory({
        fallbackUrl: entity.gradient?.toString(),
    });

    const { img: logo } = logoPictureFactory({
        fallbackUrl: entity.logo?.toString(),
    });

    const { img: background } = backgroundPictureFactory({
        fallbackUrl: entity.background?.toString(),
    });

    return (
        <CardKit.Layout
            className={styles.card}
            location={location}
            searchParams={searchParams}
            onShow={onShow}
            onClick={onClick}
            dataTid="CardShowcase"
            withShadow
        >
            <div className={styles.background}>
                {entity.gradient && (
                    <Picture
                        className={styles.gradient}
                        alt=""
                        loading="lazy"
                        srcSet={gradient.srcSet}
                        src={gradient.src}
                        data-tid="GradientImage"
                    />
                )}
                <Picture
                    className={styles.backgroundImage}
                    alt=""
                    loading="lazy"
                    srcSet={background.srcSet}
                    src={background.src}
                    data-tid="BackgroundImage"
                />
            </div>
            <div className={styles.content}>
                <Picture
                    className={styles.logo}
                    alt={entity.title}
                    loading="lazy"
                    srcSet={logo.srcSet}
                    src={logo.src}
                    data-tid="LogoImage"
                />
                <h3 className={styles.title}>{entity.title}</h3>
            </div>
        </CardKit.Layout>
    );
};
